{
  const BaseModule = require('_base/base')

  const CLASS_PLAYED = 'is__played'
  const CLASS_COVER_LOADED = 'is__coverLoaded'
  const TRANSITION_DURATION = 300

  class Video extends BaseModule {
    postInit() {
      this.$videoWrapper = this.$el
      this.$video = this.$el.find('video')[0]
      this.$cover = this.$el.find('.image')
      this.$book = this.spread._book.$el || $()

      this.isAutoplayed = this.$video.hasAttribute('autoplay')
      this.isSwitcherItem = this.$el.closest('.is__switcherItem').length > 0
      this.noControls = this.$el.hasClass('is__noControls')

      this.isLoaded = false
      this.isPaused = true

      this.setEventListeners()
    }

    setEventListeners() {
      this.$el.on('click', () => {
        if (this.isPaused) this.play()
      })

      this.$spread.on('spreadLoaded', this.load.bind(this))
      this.$spread.on('spreadOutOfSight', this.stop.bind(this))

      this.$video.addEventListener('ended', this.stop.bind(this))
      this.$cover.on('imageLoaded', () => this.$el.addClass(CLASS_COVER_LOADED))

      $(document).on('imageLoaded', (e, data) => {
        if (data && data.$el.is(this.$cover)) {
          this.$el.addClass(CLASS_COVER_LOADED)
        }
      })

      this.$book.on('videoPlay', (_, $video) => {
        if (this.$video !== $video) {
          this.pause()
        }
      })

      if (this.isAutoplayed) {
        this.setAutoplayEventListeners()
      }

      if (this.isSwitcherItem) {
        this.$spread.on('anchor', () => {
          if (!this.isPaused) {
            this.pause()
            setTimeout(() => this.$videoWrapper.removeClass(CLASS_PLAYED), TRANSITION_DURATION)
          }
        })
      }
    }

    setAutoplayEventListeners() {
      this.$spread.on('spreadActivated.autoplay webpageReady.autoplay', this.play.bind(this))
      this.$spread.on('spreadOutOfSight.autoplay', this.stop.bind(this))
    }

    setReadyToPlayEventListener() {
      this.$video.addEventListener('canplay', this.handlePlayStart.bind(this))
    }

    load() {
      if (!this.isLoaded) {
        this.$video.setAttribute('src', this.$video.getAttribute('data-src'))
        this.isLoaded = true
      }
    }

    play() {
      this.load()

      if (!this.noControls) {
        this.$video.setAttribute('controls', 'controls')
      }

      const playPromise = this.$video.play()
      if (playPromise) {
        return playPromise
          .then(this.handlePlayStart.bind(this))
          .catch(e => {
            console.error(e)

            // HACK: Safari reject this promise for autoplayed video and we start it manually
            if (this.isAutoplayed) this.playReadyVideo()
          })
      }

      this.handlePlayStart()

      return Promise.resolve()
    }

    playReadyVideo() {
      const isPlayed = !this.$video.paused

      if (isPlayed) {
        this.handlePlayStart()
      } else {
        this.setReadyToPlayEventListener()
      }
    }

    handlePlayStart() {
      this.isPaused = false
      this.$el.addClass(CLASS_PLAYED)

      this.$book.trigger('videoPlay', this.$video)
    }

    pause() {
      const playPromise = this.$video.pause()
      if (playPromise) {
        return playPromise
          .then(this.handlePlayPause.bind(this))
          .catch(e => console.error(e))
      }

      this.handlePlayPause()

      return Promise.resolve()
    }

    handlePlayPause() {
      this.isPaused = true
    }

    autoRewind() {
      this.$video.removeAttribute('controls')
      this.$video.currentTime = 0
      this.$el.removeClass(CLASS_PLAYED)
    }

    stop() {
      this
        .pause()
        .then(() => { if (this.$el.hasClass('is__autoRewind')) this.autoRewind() })
    }
  }

  $('.js__video').each(function() {
    new Video($(this))
  })
}
